import * as React from "react";
import { useTranslation } from "react-i18next";
import useNavigationTitle from "components/navigation/useNavigationTitle";
import usePluginEntities from "hooks/usePluginEntities";
import { NavDropdown, MenuItem } from "components/bootstrap";
import useHotkeysContext from "hooks/useHotkeysContext";
import NavIcon from "components/navigation/NavIcon";
import usePermissions from "hooks/usePermissions";
const HelpMenu = () => {
  const { setShowHotkeysModal } = useHotkeysContext();
  const menuItems = usePluginEntities("helpMenu");
  const { isPermitted } = usePermissions();
  const navigationTitle = useNavigationTitle();
  const { t } = useTranslation("navigation");
  const availableMenuItems = menuItems.filter((item) => isPermitted(item.permissions));
  return /* @__PURE__ */ React.createElement(NavDropdown, { title: /* @__PURE__ */ React.createElement(NavIcon, { type: "help" }), hoverTitle: t("help.title"), noCaret: true }, availableMenuItems.map((item) => {
    if ("externalLink" in item) {
      return /* @__PURE__ */ React.createElement(MenuItem, { key: item.description, component: "a", href: item.externalLink, target: "_blank", icon: "open_in_new" }, navigationTitle(item));
    }
    if ("path" in item) {
      return /* @__PURE__ */ React.createElement(MenuItem, { key: item.description, href: item.path }, navigationTitle(item));
    }
    if ("action" in item) {
      return /* @__PURE__ */ React.createElement(
        MenuItem,
        {
          key: item.description,
          onClick: () => item.action({ showHotkeysModal: () => setShowHotkeysModal(true) })
        },
        navigationTitle(item)
      );
    }
    throw Error("Help menu item must have either external link, path, or action defined");
  }));
};
export default HelpMenu;
